import { SortDirection } from '../enums/SortDirection';

export const OrderPair = <T>(
  n1: T,
  n2: T,
  direction: SortDirection = SortDirection.Ascending
) => {
  if (n1 > n2) {
    return direction === SortDirection.Ascending ? 1 : -1;
  }
  if (n1 < n2) {
    return direction === SortDirection.Ascending ? -1 : 1;
  }
  return 0;
};

export const OrderBy = <T, X>(
  values: T[],
  selector: (x: T) => X,
  direction: SortDirection = SortDirection.Ascending
) => {
  return values.sort((n1, n2) => {
    const val1 = selector(n1);
    const val2 = selector(n2);
    const num1 = Number(val1);
    const num2 = Number(val2);
    if (!isNaN(num1) && !isNaN(num2)) {
      return OrderPair(num1, num2, direction);
    } else {
      return OrderPair(val1, val2, direction);
    }
  });
};
